var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompanyArm = function SvgCompanyArm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507.87,
    height: 150.452,
    viewBox: "110.727 72.227 1904.516 564.195",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#118cab",
    fillRule: "nonzero",
    strokeMiterlimit: 16,
    clipRule: "evenodd",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.375 636.422H582.422l-44.578-111.797H294.57l-40.539 111.797H110.727L329.812 72.226h157.07l241.493 564.196ZM410.18 206.898l-79.672 219.079h167.5L410.18 206.898ZM1002.922 72.226c111.57 0 177.695 77.415 177.695 161.82 0 62.009-31.039 108.61-93.281 138.25 55.703 29.024 72.664 98.493 149.14 264.126h-149.14c-58.352-121.055-79.664-229.274-153.188-229.274h-38.976v229.274H759.648V72.226h243.274Zm-107.75 231.297h71.969c37.343 0 74.062-16.335 74.062-64.492 0-42.093-26.297-63.64-77.414-63.64h-68.617v128.132ZM1741 72.226h118.102v564.196h-135.524V283.844l-146.5 176.992h-21l-146.656-176.992v352.578H1273.82V72.226h117.946L1566.5 281.352 1741 72.227Z"
  }))));
};
export default SvgCompanyArm;